module.exports = __webpack_public_path__ + "static/img/theme1.e459cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme1.jpg
// module id = urzC
// module chunks = 1